import Image from "next/image";

import { HUBSPOT_ICON_SRC } from "@/lib/hubspot-icon";

type CcHubSpotIconProps = {
  size?: number;
  className?: string;
};

export function CcHubSpotIcon({ size = 16, className }: CcHubSpotIconProps) {
  return (
    <Image
      src={HUBSPOT_ICON_SRC}
      alt=""
      width={size}
      height={size}
      className={className}
      aria-hidden
    />
  );
}
